const enum OrderKey {
	Ascending,
	Descending
}

const enum Param {
	Avatar = 'av',
	Campaigns = 'c',
	Created = 'cr',
	Distance = 'd',
	ExecutionDistance = 'e_d',
	ExecutionLocations = 'e_loc',
	ExecutionPremium = 'e_pr',
	ExecutionStatus = 'e_s',
	GotAnswer = 'ga',
	LastContacted = 'lc',
	LinkedInQualification = 'liq',
	Locations = 'loc',
	ModalLinkedInQualification = 'm_liq',
	ModalSearchQuery = 'm_sq',
	ModalSkip = 'm_sk',
	NotAvatar = 'n_av',
	NotCampaigns = 'n_c',
	NotContacted = 'n_cnt',
	NotCreated = 'n_cr',
	NotLinkedInQualification = 'n_liq',
	Order = 'o',
	OrderModal = 'm_o',
	PersonId = 'p',
	Premium = 'pr',
	SearchQuery = 'sq',
	Skip = 's',
	Take = 't'
}

const CIRCLES = ['1st', '2nd', '3rd+'].map((label, index) => ({
	label,
	value: index + 1
}))

type CampaignKey = Param.Campaigns | Param.NotCampaigns
type CircleKey = Param.Distance | Param.ExecutionDistance
type DateKey = Param.Created | Param.LastContacted | Param.NotContacted | Param.NotCreated
type OptionCircle = (typeof CIRCLES)[number]
type OrderParam = Param.Order | Param.OrderModal
type SkipKey = Param.ModalSkip | Param.Skip

const AllowedOrder = {
	CampaignContacts: new Set([
		'contacted',
		'created',
		'custom_field_1',
		'custom_field_2',
		'custom_field_3',
		'full_name',
		'location',
		'occupation'
	] as const),
	Executions: new Set([
		'created',
		'linkedin_contact/custom_field_1',
		'linkedin_contact/custom_field_2',
		'linkedin_contact/custom_field_3',
		'linkedin_contact/contacted',
		'linkedin_contact/full_name',
		'linkedin_contact/location',
		'linkedin_contact/occupation',
		'state'
	] as const),
	General: new Set([
		'contacted',
		'created',
		'custom_field_1',
		'custom_field_2',
		'custom_field_3',
		'full_name',
		'imported',
		'location',
		'last_job/title',
		'last_job/company/name',
		'occupation'
	] as const)
}

type SortValuesMode = keyof typeof AllowedOrder

const FallbackOrder: Record<SortValuesMode, string> = {
	CampaignContacts: 'created',
	Executions: 'created',
	General: 'location'
}

export type {
	CampaignKey,
	CircleKey,
	DateKey,
	OptionCircle,
	OrderParam,
	SkipKey,
	SortValuesMode
}

export { AllowedOrder, CIRCLES, FallbackOrder, OrderKey, Param }
